export const COUNTRIES_DATA = [
  { id: 4,   iso: 'dz', name: 'Algeria',                          currency: 'DZD', enabled: true  },
  { id: 18,  iso: 'bh', name: 'Bahrain',                          currency: 'BHD', enabled: false },
  { id: 40,  iso: 'ca', name: 'Canada',                           currency: 'CAD', enabled: false },
  { id: 67,  iso: 'eg', name: 'Egypt',                            currency: 'EGP', enabled: false },
  { id: 77,  iso: 'fr', name: 'France',                           currency: 'EUR', enabled: false },
  { id: 105, iso: 'ir', name: 'Iran',                             currency: 'IRR', enabled: false },
  { id: 106, iso: 'iq', name: 'Iraq',                             currency: 'IQD', enabled: false },
  { id: 114, iso: 'jo', name: 'Jordan',                           currency: 'JOD', enabled: false },
  { id: 120, iso: 'kw', name: 'Kuwait',                           currency: 'KWD', enabled: false },
  { id: 124, iso: 'lb', name: 'Lebanon',                          currency: 'LBP', enabled: false },
  { id: 127, iso: 'ly', name: 'Libya',                            currency: 'LYD', enabled: false },
  { id: 150, iso: 'ma', name: 'Morocco',                          currency: 'MAD', enabled: false },
  { id: 167, iso: 'om', name: 'Oman',                             currency: 'OMR', enabled: false },
  { id: 170, iso: 'ps', name: 'Palestinian Territory',            currency: 'ILS', enabled: false },
  { id: 180, iso: 'qa', name: 'Qatar',                            currency: 'QAR', enabled: false },
  { id: 195, iso: 'sa', name: 'Saudi Arabia',                     currency: 'SAR', enabled: false },
  { id: 196, iso: 'sn', name: 'Senegal',                          currency: 'XOF', enabled: false },
  { id: 205, iso: 'za', name: 'South Africa',                     currency: 'ZAR', enabled: false },
  { id: 208, iso: 'es', name: 'Spain',                            currency: 'EUR', enabled: false },
  { id: 216, iso: 'sy', name: 'Syria',                            currency: 'SYP', enabled: false },
  { id: 226, iso: 'tn', name: 'Tunisia',                          currency: 'TND', enabled: false },
  { id: 233, iso: 'ae', name: 'United Arab Emirates',             currency: 'AED', enabled: false },
  { id: 235, iso: 'us', name: 'United States',                    currency: 'USD', enabled: false },
  { id: 245, iso: 'ye', name: 'Yemen',                            currency: 'YER', enabled: false },
];

export const COUNTRY_OPTIONS = COUNTRIES_DATA.map(c => ({
  value: String(c.id),
  label: c.enabled ? c.name : `${c.name} — bientôt disponible`,
  disabled: !c.enabled,
}));

export function findCountryById(id) {
  return COUNTRIES_DATA.find(c => c.id === Number(id)) ?? null;
}

export function findCountryByIso(iso) {
  return COUNTRIES_DATA.find(c => c.iso === String(iso).toLowerCase()) ?? null;
}
